import { render, staticRenderFns } from "./TuitionFeePeriod.vue?vue&type=template&id=32a5a728&scoped=true"
import script from "./TuitionFeePeriod.vue?vue&type=script&lang=js"
export * from "./TuitionFeePeriod.vue?vue&type=script&lang=js"
import style0 from "./TuitionFeePeriod.vue?vue&type=style&index=0&id=32a5a728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5a728",
  null
  
)

export default component.exports